<blaze-dialog [showCloseButton]="false" [showFooter]="false" [scroll]="false">
  @let saving = saving$ | async;

  <button icon class="icon-back" blazeIconButton [disabled]="saving" (click)="returnToBuilder()">
    <mat-icon svgIcon="icon_chevron_left_16" />
  </button>

  <div title> {{ action.data.httpMethod }} {{ action.data.name }} / Root node </div>

  <ng-container actions>
    <button (click)="save()" blazeBarButton="primary" [disabled]="saving">Save</button>

    <button blazeIconButton (click)="returnToBuilder()">
      <mat-icon svgIcon="icon_close_16" />
    </button>
  </ng-container>

  <div content class="content-wrapper">
    <blaze-scroller class="content-scroller">
      <blaze-tree-select
        class="tree-select"
        (nodeSelected)="nodeSelected($event)"
        [data$]="data$"
        [selectedPath$]="resultPath$"
      />
    </blaze-scroller>
  </div>
</blaze-dialog>
